import React from 'react';
import aabu from '../Image/arabic.png';

function Education() {
  const experiences = [
    {
      Major: "MSc in Computer Science",
      University: "Al Albayt University",
      period: "2014-2018",
      description: `While I am in my MSc computer science at Al Bayt University, my venture was into the advanced topics of distributed computing, machine learning, and data analytics. Research and peer and faculty collaboration have given me the skills to face various challenges the field has to offer. I am very well prepared for a beautiful career in computer science.
`,
      img: aabu
    },
    {
      Major: "BS in Computer Science",
      University: "Al Albayt University",
      period: "2009-2013",
      description: `I pursued a BS degree in Computer Science at Al Bayt University, where I gained knowledge in programming, data structures, algorithms, and specialized topics like artificial intelligence and machine learning. I worked on various projects and assignments, and had access to a supportive community of faculty and students. My experience prepared you for a career in a dynamic and evolving field.`,
      img: aabu
    }
  ];

  return (
    <section id="education" className="section">
      <h2>Education</h2>
      {experiences.map((exp, index) => (
        <div key={index} className="experience-item">
          <div className="experience-text">
            <h3>{exp.Major}</h3>
            <h4>{exp.company}</h4>
            <p className="period">{exp.period}</p>
            <p>{exp.description}</p>
          </div>
          <img src={exp.img.toString()} alt={exp.title} />
        </div>
      ))}
    </section>
  );
}

export default Education;
